<template>
  <BaseBoxColor variant="gray" class="w-full p-4">
    <h3>{{ name }}</h3>
    <GridRow class="mt-2">
      <GridCol :span-md="12" class="max-h-[12.5rem] flex flex-col space-y-4">
        <StandardChart v-if="chartOptions" class="h-[12.5rem] w-full" :options="chartOptions" />
      </GridCol>
    </GridRow>
  </BaseBoxColor>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { StatisticsService } from "@/api/services";

const chartOptions = ref()

const props = defineProps({
  id: Number,
  name: String,
  type: String,
});

onMounted(async () => {
  try{
    let tempStats = await StatisticsService.getStatistics("intent", props.id);
    chartOptions.value = tempStats.data.jsConfig
  } catch (e) {
    console.error(e)
  }
})
</script>
